import Styles from './PaletteSwatch.module.scss'
import { PaletteSwatchProps } from './Types'

export const PaletteSwatch = ({ colors }: PaletteSwatchProps) => (
  <div className={Styles.swatch}>
    {colors.map((hex, i) => (
      <div className={Styles.color} key={`${hex}-${i}`} style={{ backgroundColor: hex }} />
    ))}
  </div>
)
